import React from "react";
import { useAnalyzeLayout } from "../AnalyzeLayoutContext";
// import AnalyzeSpaceTab from "../../analyzeTabs/AnalyzeSpaceTab";
import AnalyzeSpaceTab from "./AnalyzeSpaceTab";



const SpacesPanel = () => {
  const { filters, setFilters } = useAnalyzeLayout();

  return (
    <>
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
        <AnalyzeSpaceTab 
          assetName={"pageName"}
          onSpaceLoad={(spaces)=> {}}
          onDateChange={(dateRange)=> {}}
        />
      </div>
    </>
  )
}

export default SpacesPanel;